import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import BoardTree from "./BoardTree";
import BoardView from "./BoardView";
import { items, menuAdmin } from "@recoil/Store";
import { useRecoilState, useRecoilValue } from "recoil";
import { useLocation } from "react-router-dom";
import * as Const from "@utils/Const";
import BoardList from "./BoardList";
import BoardCreate from "./BoardCreate";
import BoardReply from "./BoardReply";
import BoardUpdate from "./BoardUpdate";
export default function BoardMain() {
    const { pathname } = useLocation();
    const [item, setItem] = useRecoilState(items);
    const menus = useRecoilValue(menuAdmin);
    let curMenu = menus && menus.filter((val) => (val.tabUrl === pathname))[0];
    let menu = curMenu && curMenu.subMenus;
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "admin-body" }, { children: [menu && _jsx(BoardTree, { menu: menu, tem: item, setItem: setItem }), (item && item.tab === Const.AD_B) && _jsx(BoardList, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_V) && (item.tab === Const.AD_B) && _jsx(BoardView, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_P) && (item.tab === Const.AD_B) && _jsx(BoardUpdate, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_C) && (item.tab === Const.AD_B) && (item.depth2.url !== Const.URL_CONTACT) && _jsx(BoardCreate, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_C) && (item.tab === Const.AD_B) && (item.depth2.url == Const.URL_CONTACT) && _jsx(BoardReply, { item: item, setItem: setItem })] })) }));
}
